import {
  faHome,
  faMoneyBillWave,
  faTshirt,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useHistory } from "react-router-dom";
import "./NavigationBar.Styles.scss";
import { NavigationItem } from "./NavigationItem.Interface";

interface Props {
  active: string;
  setActive: (str: string) => void;
  navigationActive: boolean;
}

export default function NavigationBar(props: Props) {
  const history = useHistory();

  const navItems: NavigationItem[] = [
    {
      title: "Home",
      icon: faHome,
      onClick: () => {},
      key: "",
    },
    {
      title: "Teams",
      icon: faUsers,
      onClick: () => {},
      key: "teams",
    },
    {
      title: "Our Kits",
      icon: faTshirt,
      onClick: () => {},
      key: "kits",
    },
    {
      title: "Sponsors",
      icon: faMoneyBillWave,
      onClick: () => {},
      key: "sponsors",
    },
  ];

  const onClickItem = (ele: NavigationItem) => {
    props.setActive(ele.key);
    history.push("/" + ele.key);
  };

  const renderNavElements = () => {
    return navItems.map((ele, id) => {
      return (
        <li
          className={props.active === ele.key ? "active" : ""}
          key={id}
          onClick={() => onClickItem(ele)}
        >
          <span>{ele.title}</span>
          <FontAwesomeIcon icon={ele.icon} />
        </li>
      );
    });
  };

  return (
    <div
      className={`navigation ${
        props.navigationActive ? "navigation-active" : ""
      }`}
    >
      <ul>{renderNavElements()}</ul>
    </div>
  );
}
